import { useMemo } from 'react';
import AccountViews from '../../../AccountGetsMarried/constants/AccountViews';

export default (viewName: any) =>
  useMemo(() => {
    switch (viewName) {
      default:
      case AccountViews.GetCare:
        return 0;
      case AccountViews.Manage:
        return 1;
      case AccountViews.Chat:
        return 2;
      case AccountViews.Insurance:
        return 3;
      case AccountViews.Profile:
        return 4;
    }
  }, [viewName]);
